import React from 'react';
import { Link } from "react-router-dom";
import Iconify from '../../../layouts/components/iconify/iconify'; 

export const renderGridAction = (rowData, col, rowIndex, onActionHandler) => {
  if (!col.defaultAction) {
    col.defaultAction = {
      allowEdit: true,
      allowDelete: true,
    };
  }

  if (col.renderCustomAction) {
    col.renderCustomAction(rowData, col);
  }

  const handleAction = (actionName, data, rowIndex) => {
    if (onActionHandler && onActionHandler[actionName]) {
      onActionHandler[actionName](data);
    }
  };

  return (
    <div className="action-button">
      {col.customAction &&
        col.customAction.length > 0 &&
        col.customAction.map((action, index) => {
          const commonLinkProps = {
            key: `customAction_${index}`,
            onClick: (e) => {
              e.preventDefault();
              handleAction(action.name, rowData);
            },
            title: action.name,
            href: "",
          };
          // Add condition to check if rowData.contractInputFile is present
          if (action.name === "DOWNLOAD" && !rowData.contractInputFile) {
            return null;
          } else {
            // Render null if rowData.contractInputFile is not present
            return (
              <Link {...commonLinkProps}>
                <div className="icon-container">
                  {action.name === "DOWNLOAD" && (
                    <span className="icon">
                      {/* Replace with your icon */}
                      <Iconify icon="solar:person-bold" />
                    </span>
                  )}
                </div>
              </Link>
            );
          }
        })}
      {col.defaultAction.allowEdit && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            handleAction("EDIT", rowData);
          }}
          title="EDIT"
        >
          <div className="icon-container">
            <button className="icon-button">
              <Iconify icon="line-md:pencil" />
            </button>
          </div>
        </Link>
      )}

      {col.defaultAction.allowDelete && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            handleAction("DELETE", rowData);
          }}
          title="DELETE"
        >
          <div className="icon-container">
            <button className="icon-button icon_Delete">
              <Iconify icon="mingcute:delete-2-line" />
            </button>
          </div>
        </Link>
      )}
    </div>
  );
};
